import React from "react";
var StockswithDot = function (props) {
    return (React.createElement("div", { className: "d-flex align-items-center gap-5-custom  txt_secondary-gray DMSanN_12_400" },
        React.createElement("span", { className: "generic-stock-time" }, props.stockName),
        !!props.subStockName && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "round-circle-search" },
                React.createElement("i", { className: "edel-icon-round-circle " })),
            React.createElement("span", { className: "generic-stock-date" }, props.subStockName)))));
};
export default StockswithDot;
